import { addHours, differenceInSeconds } from 'date-fns';

import { ConnectedService } from './connected-service';

export const CANCEL_RESCHEDULE_CUTOFF_TIME_OPTIONS = [
  'Cancel or reschedule at any time',
  'Patient not allowed to cancel or reschedule',
  '1 hour',
  '2 hours',
  '3 hours',
  '6 hours',
  '12 hours',
  '24 hours',
  '48 hours',
  '3 days',
  '1 week',
  '2 weeks',
];
export class OnlineBookingConfigService extends ConnectedService {
  constructor(callback, date = new Date()) {
    super({
      bookingConfig: 'onlineBooking.item',
    });

    this.__date = date;
    this.onStateChanged = callback;
  }

  _stateChanged({ bookingConfig }) {
    this.onStateChanged({
      ...bookingConfig,
      allowCancelReschedule: this.allowCancelReschedule(),
    });
  }

  update(date) {
    this.__date = date;
    this.updateState();
  }

  allowCancelReschedule(date = this.__date) {
    if (!this._oldValues) return false;

    const { bookingConfig } = this._oldValues;

    switch (bookingConfig && bookingConfig.cancelRescheduleCutOffTime) {
      case 'Cancel or reschedule at any time':
        return true;

      case '1 hour':
        return differenceInSeconds(date, addHours(new Date(), 1)) > 0;

      case '2 hours':
        return differenceInSeconds(date, addHours(new Date(), 2)) > 0;

      case '3 hours':
        return differenceInSeconds(date, addHours(new Date(), 3)) > 0;

      case '6 hours':
        return differenceInSeconds(date, addHours(new Date(), 6)) > 0;

      case '12 hours':
        return differenceInSeconds(date, addHours(new Date(), 12)) > 0;

      case '24 hours':
        return differenceInSeconds(date, addHours(new Date(), 24)) > 0;

      case '48 hours':
        return differenceInSeconds(date, addHours(new Date(), 48)) > 0;

      case '3 days':
        return differenceInSeconds(date, addHours(new Date(), 72)) > 0;

      case '1 week':
        return differenceInSeconds(date, addHours(new Date(), 24 * 7)) > 0;

      case '2 weeks':
        return differenceInSeconds(date, addHours(new Date(), 24 * 14)) > 0;

      case 'Patient not allowed to cancel or reschedule':
      default:
        return false;
    }
  }
}
